import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BlockNodeEnum } from '@app/core/enums';
import { MixedObject } from '@app/core/interfaces/mixed-object';
import { Block } from '@app/core/models/block/block.model';

export class scryptHTML {
  key: string;
  body: HTMLElement;
}

@Injectable({providedIn: 'root'})
export class ScryptZMailerLite {
  itemMap: Record<string, Block> = {};

  // item: Block;

  scryptHTML: Record<string, scryptHTML> = {};

  // iframeScriptContent: SafeHtml = '';
  iframeScriptContent: Record<string, SafeHtml> = {};

  iframeContent: SafeHtml = '';
  blockStyles: MixedObject = {};
  setInnerHTML = true;
  private inlineId = 'inline-urlscript' + Date.now();
  private externalId = 'external-urlscript' + Date.now();

  constructor(private sanitizer: DomSanitizer) {
  }

  private parsScript(item): void {
    if (
      this.itemMap[item.uId] &&
      this.itemMap[item.uId].content &&
      typeof this.itemMap[item.uId].content === 'string'
    ) {
      this.itemMap[item.uId].content = this.itemMap[item.uId].content?.replace(
        // tslint:disable-next-line:max-line-length
        '<input aria-label=email aria-required=true type=email class=form-control data-inputmask= name=fields[email] placeholder=Email autocomplete=email>',
        // tslint:disable-next-line:max-line-length
        '<input value=Email aria-label=email aria-required=true type=email class=form-control data-inputmask= name=fields[email] placeholder=Email autocomplete=email>',
      );
    }
  }

  setIframeScriptContentHtml(item): void {
    this.parsScript(item);
    const {content = '', node} = this.itemMap[item.uId];

    if (
      node !== BlockNodeEnum.IFRAME_SCRIPT ||
      !content ||
      this.iframeScriptContent[item.uId]
    ) {
      return;
    }

    this.getScript(item);
    if (
      node !== BlockNodeEnum.IFRAME_SCRIPT ||
      !content.includes('URLSCRIPT')
    ) {
      this.iframeScriptContent[item.uId] =
        this.sanitizer.bypassSecurityTrustHtml(content);
    }
  }

  private getScript(item): void {
    const {content = '', node} = this.itemMap[item.uId];
    if (
      node !== BlockNodeEnum.IFRAME_SCRIPT ||
      !content.includes('URLSCRIPT')
    ) {
      return;
    }

    const arrGetUrl = content.split('URLSCRIPT:');
    const tagArre = arrGetUrl[0].split('</script>');
    tagArre.forEach((e) => {
      if (e.includes('<script>')) {
        const script = document.createElement('script');
        script.id = this.inlineId;
        const scriptdelet = e.replace('<script>', ' ');
        script.innerHTML = `${scriptdelet}`;
        script.async = true;
        document.head.appendChild(script);
      } else {
        if (!this.itemMap[item.uId].content.includes('mailerlite')) {
          this.iframeScriptContent[item.uId] =
            this.sanitizer.bypassSecurityTrustHtml(e);
        }
      }
    });

    if (arrGetUrl[1]) {
      const script = document.createElement('script');
      script.id = this.externalId;
      script.src = `${arrGetUrl[1]}`;
      script.async = true;
      document.head.appendChild(script);
    }
  }

  extractDivAttributes(item): { class: string; dataForm: string } {
    const parser = new DOMParser();
    const doc = parser.parseFromString(
      this.itemMap[item.uId].content || '',
      'text/html',
    );
    const embeddedDiv = doc.querySelector('.ml-embedded');
    return {
      class: embeddedDiv?.getAttribute('class') || 'ml-embedded',
      dataForm: embeddedDiv?.getAttribute('data-form') || '',
    };
  }
}
